import { AxiosResponse } from "axios";
import { call, put, select, takeLatest } from "redux-saga/effects";
import { AppService } from "src/services/app";
import { getBaseUrl } from "../selectors/features/app";
import { RequestTypes } from "../types";
import { updateFcmTokenFailure, updateFcmTokenSuccess } from "../slices/features/fcm";

const appService = new AppService();

function* updateFcmTokenSaga(action: any) {
  const { payload } = action;
  const { data } = payload;

  try {
    const baseUrl: string = yield select(getBaseUrl);

    const response: AxiosResponse<any> = yield call(
      appService.updateFcmToken,
      baseUrl,
      data
    );

    payload?.cbSuccess && payload?.cbSuccess({ ...response });

    yield put(updateFcmTokenSuccess({ ...response }));
  } catch (errors: any) {
    const { statusCode, statusText } = errors;
    const message = errors?.data?.errors?.message;

    payload?.cbFailure && payload?.cbFailure(message);

    yield put(updateFcmTokenFailure({ statusCode, statusText }));
  }
}

export function* watchupdateFcmToken() {
  yield takeLatest(
    RequestTypes.UPDATE_FCM_TOKEN_REQUEST,
    updateFcmTokenSaga
  );
}
